import classNames from 'classnames'
import Checkbox from '../Checkbox'
import {getAllSelector, isAllChecked, isAllOptionsIndividuallyChecked} from './MultiUtils'

export default function MultiOptionRenderer (onSelectionChange) {
  return function (params) {
    const allChecked = isAllChecked(params.options)
    const checked = params.option.checked || allChecked
    const classes = { // see note below
      'checkboxed-option': true,
      'checkboxed-option-all-selector': params.option.selectAll
    }
    const handleSelect = () => {
      let newOptions = params.options.map(option => { return {...option, checked: option.checked || allChecked} })
      if (params.option.selectAll) { // 'all selector' was clicked -> check/un-check all
        newOptions.forEach(option => { option.checked = !checked })
      } else { // a 'regular' option was clicked
        newOptions
          .filter(option => option.value === params.option.value) // locate current option
          .forEach(option => { option.checked = !option.checked }) // toggle it
        const allSelector = getAllSelector(newOptions)
        allSelector && (allSelector.checked = isAllOptionsIndividuallyChecked(newOptions))
      }
      onSelectionChange && onSelectionChange(newOptions)
    }
    const noop = Function.prototype // dummy function - just to let the checkbox know that _we_ manage its state

    return (
      <div className={classNames(classes)} style={params.style} key={params.option.value} onClick={handleSelect}>
        <Checkbox checked={checked} label={params.option.label} onChange={noop} />
      </div>
    )
  }
}

/* note:
 Tried to piggyback the existing style already defined for the default renderer, by adding:
   'VirtualizedSelectFocusedOption': params.option === params.focusedOption
 and adding this to the div we return:
   onMouseOver={() => {params.focusOption(params.option)}}
 This works fine when just hovering over the options.
 But when selecting any option, for some reason the focusedOption always reset to the first option.

 TL;DR - in this custom renderer, we just use the :hover pseudo class for mouse over effect.
 */



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Select/MultiOptionRenderer.js